import React from "react";
import {Icon} from "@iconify/react";

export const getIcon = (name: any) => <Icon icon={name} width={22} height={22} style={{cursor: "pointer"}}/>;